export default "__VITE_ASSET__CaVwZW6M__"